
const digest = '566b5d04e75d59637fe45b70e9b02bec9c14587779c59aa9e6a03e46217f8211';
const classes = {"wrapper":"_wrapper_1se7w_1","header":"_header_1se7w_6","title":"_title_1se7w_15","button":"_button_1se7w_21"};
const css = `._wrapper_1se7w_1 {
  max-height: 400px;
  margin-bottom: 75px;
}

._header_1se7w_6 {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  padding: 24px;
}

._title_1se7w_15 {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

._button_1se7w_21 {
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  display: flex;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  